import { useId } from 'react';
import {
	StyledBackCircle,
	StyledGroup,
} from './AppCircuitGameNodePoint.styled';

const AppCircuitGameNodePoint = ({
	cx,
	cy,
	...props
}: { cx: number; cy: number } & React.HTMLAttributes<SVGElement>) => {
	const id = useId();

	return (
		<StyledGroup {...props}>
			<defs>
				<radialGradient
					id={`paint0_radial_${id}`}
					cx={cx}
					cy={cy}
					r="30"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="white" stopOpacity="0" />
				</radialGradient>
			</defs>
			<StyledBackCircle
				opacity="0.5"
				cx={cx}
				cy={cy}
				r="30"
				fill={`url(#paint0_radial_${id})`}
			/>
			<circle cx={cx} cy={cy} r="15" fill={`url(#paint1_linear_${id})`} />
			<circle
				cx={cx}
				cy={cy}
				r="11.5"
				fill={`url(#paint2_linear_${id})`}
				stroke="white"
			/>
			<circle cx={cx} cy={cy} r="5" fill="black" />
			<defs>
				<filter
					id={`filter0_d_${id}`}
					cx={cx - 11}
					cy={cy - 11}
					width="22"
					height="22"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="3" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result={`effect1_dropShadow_${id}`}
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2={`effect1_dropShadow_${id}`}
						result="shape"
					/>
				</filter>
				<linearGradient
					id={`paint1_linear_${id}`}
					x1={cx}
					y1={cy - 15}
					x2={cx}
					y2={cy + 15}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="#C9C9C9" />
				</linearGradient>
				<linearGradient
					id={`paint2_linear_${id}`}
					x1={cx}
					y1={cy + 12}
					x2={cx}
					y2={cy - 12}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset="1" stopColor="#C9C9C9" />
				</linearGradient>
			</defs>
		</StyledGroup>
	);
};

export { AppCircuitGameNodePoint };
